//dependencias
import React, { Component } from 'react';

//componentes
import MateriasAAction from './materiasA'

class Index extends Component {

    render(){
        return(
            <div>
                <MateriasAAction />
            </div>
        );
    }

}
export default Index;